// extracted by mini-css-extract-plugin
export default {"desc":"ReadMore_desc__Oggus","para":"ReadMore_para__VbJSX"};